import globalAxios from "axios";

import { Warn } from "@helpers";

const addInterceptors = (): void => {
  const publicPaths = [
    "/login",
    "/register",
    "/reset-password",
    "/password-recovery",
    "/register-supplier",
    "/csob-auth",
    "/dm-survey",
    "/sso-login",
  ];

  const isPublicPath = (pathname: string): boolean =>
    publicPaths.some((path) => pathname.startsWith(path));

  globalAxios.interceptors.request.use(function (config) {
    const token = localStorage.getItem("access_token");

    if (!token) return config;
    config.headers.Authorization = `Bearer ${localStorage.getItem("access_token")}`;

    return config;
  });

  globalAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        const refreshToken = localStorage.getItem("refresh_token");
        const activeCompanyId = localStorage.getItem("activeCompanyId");
        const shouldRedirectToLogin = !isPublicPath(window.location.pathname);

        if (refreshToken) {
          try {
            const response = await fetch(
              `${import.meta.env.VITE_API_BASE_URL}/auth/refresh`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams({
                  refresh_token: refreshToken,
                  company_id: activeCompanyId || "",
                }),
              },
            );

            if (response.status === 200) {
              const data = await response.json();

              localStorage.setItem("access_token", data.access_token);
              originalRequest.headers.Authorization = `Bearer ${data.access_token}`;

              return globalAxios(originalRequest);
            } else {
              Warn("Refresh token failure.");
              handleTokenRefreshFailure(shouldRedirectToLogin);
            }
          } catch {
            Warn("Refresh token failure.");
            handleTokenRefreshFailure(shouldRedirectToLogin);
          }
        } else {
          Warn("No refresh token found.");
          handleTokenRefreshFailure(shouldRedirectToLogin);
        }
      }

      return Promise.reject(error);
    },
  );
};

const handleTokenRefreshFailure = (shouldRedirect = true): void => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  if (shouldRedirect) {
    const intendedUrl = window.location.pathname + window.location.search;

    sessionStorage.setItem("redirectAfterLogin", intendedUrl);
    window.location.href = "/login";
  }
};

const configureBaseUrl = (): void => {
  // TODO replace with ENV var
  // TODO This doen't work with the current setup -> need to change contracts package
  globalAxios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;
};

export const configureAxios = (): void => {
  configureBaseUrl();
  addInterceptors();
};
